import { render, staticRenderFns } from "./complainForm.vue?vue&type=template&id=7e2ad3e2&scoped=true"
import script from "./complainForm.vue?vue&type=script&lang=js"
export * from "./complainForm.vue?vue&type=script&lang=js"
import style0 from "./complainForm.vue?vue&type=style&index=0&id=7e2ad3e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ad3e2",
  null
  
)

export default component.exports